import axios from "utils/axiosConfig";
import uri from "../config";

// Enable sending cookies with requests

export const getConfig = () => {
  const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
  // Fix: Check user.data.token first (correct structure), fallback to user.token
  const token = user ? (user.data && user.data.token) || user.token : null;

  const config = {
    headers: {
      // Authorization header no longer needed with HTTP-Only cookies
    },
  };

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

// Request interceptor to add the auth token header to requests
axios.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
    // Fix: Check user.data.token first, fallback to user.token
    const token = user ? (user.data && user.data.token) || user.token : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const regUser = async (data) => {
  const response = await axios.post(`${uri}/api/user`, data);

  if (response.data) {
    localStorage.setItem("shopifyeco-user", JSON.stringify(response.data));
  }

  return response.data;
};

const loginUser = async (data) => {
  const response = await axios.post(`${uri}/api/user/login`, data);

  if (response.data) {
    localStorage.setItem("shopifyeco-user", JSON.stringify(response.data));
  }

  return response.data;
};

const logout = async () => {
  try {
    await axios.post(`${uri}/api/user/logout`);
  } catch (error) {
    console.error("Logout failed", error);
  }
  localStorage.removeItem("shopifyeco-user");
};

const updateProfile = async (email, profileData) => {
  const response = await axios.post(
    `${uri}/api/user/profile`,
    {
      email,
      profileData,
    },
    getConfig()
  );

  if (response.data) {
    // preserve token from existing local storage
    const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
    const token = user ? (user.data && user.data.token) || user.token : null;

    // Create new data object preserving the token
    const newData = {
      ...response.data,
      data: {
        ...response.data.data,
        token: token,
      },
    };

    localStorage.setItem("shopifyeco-user", JSON.stringify(newData));
  }

  return response.data;
};

const addAddress = async (email, address) => {
  const response = await axios.post(
    `${uri}/api/user/address`,
    {
      email,
      address,
    },
    getConfig()
  );

  if (response.data) {
    // preserve token from existing local storage
    const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
    const token = user ? (user.data && user.data.token) || user.token : null;

    const newData = {
      ...response.data,
      data: {
        ...response.data.data,
        token: token,
      },
    };
    localStorage.setItem("shopifyeco-user", JSON.stringify(newData));
  }
  return response.data;
};

const removeAddress = async (email, id) => {
  const response = await axios.delete(`${uri}/api/user/address`, {
    data: { email, id },
    ...getConfig(),
  });

  if (response.data) {
    // preserve token from existing local storage
    const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
    const token = user ? (user.data && user.data.token) || user.token : null;

    const newData = {
      ...response.data,
      data: {
        ...response.data.data,
        token: token,
      },
    };
    localStorage.setItem("shopifyeco-user", JSON.stringify(newData));
  }
  return response.data;
};

const addCard = async (email, card) => {
  const response = await axios.post(
    `${uri}/api/user/card`,
    {
      email,
      card,
    },
    getConfig()
  );

  if (response.data) {
    // preserve token from existing local storage
    const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
    const token = user ? (user.data && user.data.token) || user.token : null;

    const newData = {
      ...response.data,
      data: {
        ...response.data.data,
        token: token,
      },
    };
    localStorage.setItem("shopifyeco-user", JSON.stringify(newData));
  }
  return response.data;
};

const removeCard = async (email, id) => {
  const response = await axios.delete(`${uri}/api/user/card`, {
    data: { email, id },
    ...getConfig(),
  });

  if (response.data) {
    // preserve token from existing local storage
    const user = JSON.parse(localStorage.getItem("shopifyeco-user"));
    const token = user ? (user.data && user.data.token) || user.token : null;

    const newData = {
      ...response.data,
      data: {
        ...response.data.data,
        token: token,
      },
    };
    localStorage.setItem("shopifyeco-user", JSON.stringify(newData));
  }
  return response.data;
};

const authService = {
  regUser,
  loginUser,
  logout,
  updateProfile,
  addAddress,
  removeAddress,
  addCard,
  removeCard,
};

export default authService;
